/** Items fetched per page by paginated views: large enough that the first page fills the screen in one call. */
export const DEFAULT_PAGE_SIZE = 25
